import {
  Client,
  clientFromDto,
  clientMOFromClient,
  ClientSummary,
  ClientSummaryDto,
  clientSummaryFromDto,
} from '../../2_domain/client/client';
import IClientRepository from '../../2_domain/client/iClientRepository';
import { toKRString } from '../../lib/util/dateFormatter';
import Connection2 from '../core/connection2';

class ClientRepository implements IClientRepository {
  //LINK - id 42
  //NOTE - pagination - DONE
  getClients = async (param: {
    searchText: string;
    pagination: Pagination;
    fromDate?: Date;
    endDate?: Date;
  }): Promise<{ page: Page; list: ClientSummary[] }> => {
    let dateRange: { begin: string; end: string } | undefined;
    if (param.fromDate && param.endDate) {
      dateRange = {
        begin: toKRString(param.fromDate),
        end: toKRString(param.endDate),
      };
    }
    const { page, list } = await Connection2.requestPost(
      'clinic/pass/queryClinicPatientList',
      {
        pageNumber: param.pagination.pageNumber,
        pageSize: param.pagination.pageSize,
        searchKeyword: param.searchText === '' ? null : param.searchText,
        ...dateRange,
      }
    );
    return {
      page: page,
      list: list.map((clientSummaryDto: ClientSummaryDto) =>
        clientSummaryFromDto(clientSummaryDto)
      ),
    };
  };

  // LINK - id 43
  getClientById = async (clientId: number): Promise<Client> => {
    const { code, ...res } = await Connection2.requestPost(
      'clinic/pass/queryClinicPatientById',
      {
        id: clientId,
      }
    );
    return clientFromDto(res);
  };

  //LINK - id 44
  createClient = async (client: Client): Promise<void> => {
    await Connection2.requestPost(
      'clinic/pass/createClinicPatient',
      clientMOFromClient(client)
    );
    return;
  };

  //LINK - id 45
  updateClient = async (client: Client): Promise<void> => {
    await Connection2.requestPatch(
      'clinic/pass/updateClinicPatient',
      clientMOFromClient(client)
    );
    return;
  };

  // LINK - id 46
  //NOTE - NA
  //REVIEW - 미작성 재검토 필요
  deleteClient = async (
    clientId: Id,
    withCascading: boolean
  ): Promise<void> => {
    await Connection2.requestPost('clinic/pass/deleteClinicPatient', {
      id: clientId,
      isCascade: withCascading,
    });
    return;
  };
}

export default ClientRepository;
